const stateBase = () => ({
  show: false,
  editMode: false,
  room: {},
})

export const state = stateBase;

export const getters = {};

export const mutations = {
  RESET(store) {
    Object.assign(store, stateBase());
  },
  SET_SHOW(store, show) {
    store.show = show;
  },
  SET_EDIT_MODE(store, editMode) {
    store.editMode = editMode;
  },
  SET_ROOM(store, room) {
    store.show = true;
    store.room = room;
  },
};

export const actions = {
  setEmailAndEdit({commit}, room) {
    commit('SET_ROOM', room)
    commit('SET_EDIT_MODE', true)
    commit('SET_SHOW', true)
  },
};
